document.addEventListener('contextmenu', event => event.preventDefault());
const $filterInput = document.querySelector('.ayurpedia-filter-input');
document.querySelectorAll('.category-list button').forEach(($button) => {
            $button.addEventListener('click', () => {
                if (!$button.classList.contains('disabled')) {
                    filterayurpedias('');
                    $filterInput.value = '';
                    document.querySelector('.category-list button.active').classList.remove('active');
                    $button.classList.add('active');
                    let handle = $button.getAttribute('data-target');
                    document.querySelector('.category-group.active').classList.remove('active');
                    document.querySelector(`.category-group[data-group="${handle}"]`).classList.add('active');
                     $(`.category-group[data-group="${handle}"] .ayurpedia-item`).removeClass('hidden');
                }
            })
        })
document.querySelector('.ayurpedia-filter-trigger').addEventListener('click', () => {
            const $filter = document.querySelector('.ayurpedia-filter-wrapper');
            if ($filter) {
                $filter.classList.toggle('hidden');
            }
        })
document.addEventListener('click', (e) => {
            const $target = e.target;
            if ($target.classList.contains('ayurpedia-filter-trigger') || $target.closest('.ayurpedia-filter-trigger') || $target.classList.contains('ayurpedia-filter-input')) {
            } else {
                const $filter = document.querySelector('.ayurpedia-filter-wrapper');
                if ($filter) {
                    $filter.classList.add('hidden');
                }
            }
        })
if ($filterInput) {
            $filterInput.addEventListener('keydown', () => {
                setTimeout(() => {

                    filterayurpedias($filterInput.value);
                })
            })
        }
const filterayurpedias = (k) => {
            let keyword = k.toLowerCase();
          if(keyword == "")
          {
                     $('.category-list button').removeClass('active');
                   $('.ayurpedia-category .category-group').removeClass('active');
                   $('.category-list button').eq(1).addClass('active');
                   $('.ayurpedia-category .category-group').eq(1).addClass('active');
          }
          else
          {
            document.querySelectorAll('.ayurpedia-category .ayurpedia-item').forEach(($ayurpedia) => {
                let i_title = $ayurpedia.querySelector('.item-title').innerHTML.toLowerCase();
                let i_content = $ayurpedia.querySelector('.item-content').innerHTML.toLowerCase();
                if (i_title.includes(keyword)) {
                    $ayurpedia.classList.remove('hidden');
                    var letter = i_title[0].toUpperCase();
                   $('.category-list button').removeClass('active');
                   $('.ayurpedia-category .category-group').removeClass('active');
                   $('.category-list [data-target="'+letter+'"]').addClass('active');
                   $('.ayurpedia-category .category-group[data-group="'+letter+'"]').addClass('active');
                } else {
                   
                    $ayurpedia.classList.add('hidden');
                }
            }) 
          }
           
        }
$(document).ready(function() {
  $(".toggle-desc").click(function() {
    var text_data = $(this).closest('.ayurpedia-item').find('.item-content');
    var elem = $(this).text();
    var readattr = $(this).attr('data-operation');
    if (readattr == "readmore") {
      $(this).attr('data-operation',"readless");
      $(this).text("Read Less");
      $(text_data).removeClass('hideele');
    } else {
      $(this).attr('data-operation',"readmore");
      $(this).text("Read More");
      $(text_data).addClass('hideele');
    }
  });
  $('.category-list button').sort(function(a, b) {
  if (a.textContent < b.textContent) {
    return -1;
  } else {
    return 1;
  }
}).appendTo('.category-list');
});




